<template>
  <div
    class="flex items-center justify-center rounded-xl p-[1px]"
    :class="active ? 'gold-border-wrapper' : 'primary-border-wrapper'"
  >
    <button
      v-bind="$attrs"
      class="bg-primary-mid rounded-xl cursor-pointer text-2xl font-bold w-full h-full"
      :class="[{ 'gold-gradient': active }]"
      @click="$emit('click')"
    >
      <slot />
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped></style>
